import React, { Component } from 'react';

import {
  Image,
  Dimensions,
  View,
  Animated,
  Easing,
  TouchableOpacity,
  Text,
  PanResponder,
  TextInput,
  ScrollView,
  Linking,

} from 'react-native';

import ReactGA from 'react-ga';

import { MainColor, urls } from './Controller';
import { Icon, SocialIcon } from 'react-native-elements';

import * as Animatable from 'react-native-animatable';

//import Snow from 'react-native-snow'; <Snow snowfall="light" />
import SnowStorm from 'react-snowstorm';

import {appstrings} from './translate/Strings';

import Svg, {
  Rect,
  Stop,
  RadialGradient,


} from 'react-native-svg';

import AdventskalenderDataJson from './AdventskalenderDataJson';

const doorBorderWidth = 2;
const doorBorderColor = '#ffffff'
const doorNumberColor = '#ffffff'

const anim = 0;

export default class Adventskalender extends Component {

    constructor() {
    super();
    this.animatedRotateY = new Animated.Value(0);
    this.animatedTranslateX = new Animated.Value(0);

    this.gewinnX = new Animated.Value(anim);
    this.gewinnY = new Animated.Value(anim);
    this.gewinnZindex = new Animated.Value(anim);
    this.gewinnWidth = new Animated.Value(anim);
    this.gewinnHeight = new Animated.Value(anim);
    this.gewinnShadow = new Animated.Value(anim);
    this.gewinnMargin = new Animated.Value(anim);

    this.value1 = 0;
    this.value2 = 0;

    this.valueGX = 0;
    this.valueGY = 0;
    this.valueFS = 0;
    this.valueZi = 0;
    this.valueW = 0;
    this.valueH = 0;
    this.valueSW = 0;
    this.valueGM = 0;

    this.animatedRotateY.addListener(({ value }) => {
      this.value1 = value;
    });
    this.animatedTranslateX.addListener(({ value }) => {
      this.value2 = value;
    });

    this.gewinnX.addListener(({ value }) => {
      this.valueGX = value;
    });
    this.gewinnY.addListener(({ value }) => {
      this.valueGY = value;
    });
    this.gewinnZindex.addListener(({ value }) => {
      this.valueZi = value;
    });
    this.gewinnWidth.addListener(({ value }) => {
      this.valueW = value;
    });
    this.gewinnHeight.addListener(({ value }) => {
      this.valueH = value;
    });
    this.gewinnShadow.addListener(({ value }) => {
      this.valueSW = value;
    });
    this.gewinnMargin.addListener(({ value }) => {
      this.valueGM = value;
    });

        this.state = {

            isOpen: false,

            data: [],

            width: 0,
            height: 0,
            isAdminMode: false,
            adminMode: 'pc',
            showAdminData: false,
            pan: new Animated.ValueXY(),

            adminActiveWidth: 140,
            adminActiveHeight: 140,
            adminActiveNr: 1,

            mouseOverDoor: 0,

            gewinnViewTop: -500,
            gewinnViewLeft: -500,
            gewinnViewWidth: 0,
            gewinnViewHeight: 0,

            tagesGewinnText: '',
            gewinnText: '',
            gewinnGutscheincode: '',
            gewinnGutscheincodeTitel: '',
            gewinnGutscheincodeHaltbarkeit: '',


            showCloseDialogBtn: false,
            showWeiterDialogBtn: false,
            showWeiterDialogBtn2: false,
            showSozialMediaBtns: false,
            showDialog: false,
            showGewinn: false,
            showGift: true,
            showDoors: true,

            backgroundImageLoaded1: false,
            backgroundImageLoaded2: false,

            showFalscherTagDialog: false,
            falscherTagDialogText: '',

            showData: true,

        }
}



componentDidMount() {

    this._val = { x:0, y:0 }
    this.state.pan.addListener((value) => this._val = value);
           // Initialize PanResponder with move handling
    this.panResponder = PanResponder.create({
         onStartShouldSetPanResponder: (e, gesture) => true,
         onPanResponderGrant: (e, gesture) => {
           this.state.pan.setOffset({
             x: this._val.x,
             y: this._val.y
           })
           this.state.pan.setValue({ x:0, y:0})
         },
         onPanResponderMove: Animated.event([
           null, { dx: this.state.pan.x, dy: this.state.pan.y }
         ])
    });

    let gewinnText = this.props.gewinnText;
    let gewinnGutscheincode = this.props.gewinnGutscheincode;
    let gewinnGutscheincodeHaltbarkeit = this.props.gewinnGutscheincodeHaltbarkeit;

    let data = null;

    if ( this.props.width > this.props.height ){
        data = AdventskalenderDataJson.landscapeData;
    } else {
        data = AdventskalenderDataJson.portraitData;
    }

    this.setState({
                    gewinnGutscheincodeTitel: appstrings().strings.gutscheincode,
                    gewinnText: appstrings().strings.glueckwunsch+appstrings().strings.gewinnText1+gewinnText+appstrings().strings.gewinnText2,
                    tagesGewinnText: gewinnText,
                    gewinnGutscheincode: gewinnGutscheincode,
                    gewinnGutscheincodeHaltbarkeit: gewinnGutscheincodeHaltbarkeit,
                    data: data,
                    adminActiveWidth: 200,
                    adminActiveHeight: 200,
                    width: this.props.width,
                    height: this.props.height,
                    });

    if ( this.props.isAdminMode ){
        this.setState({ isAdminMode: true });this.props.showLoader(false);
    }
    if ( this.props.googleAnalytics ){
        ReactGA.pageview('Adventskalender');
        //this.sendDataToGoogle('User','Device => '+this.props.deviceArt);
    }
    //ZUM TESTEN DER DIALOGE
    //setTimeout(() => { this.changeGewinnText(0); }, 1000);
}

sendDataToGoogle(kategorie,aktion){
if ( this.props.googleAnalytics ){
    ReactGA.event({
                  category: kategorie,
                  action: aktion
                });
}
}

reset(){
    this.setState({ showDialog: false, backgroundImageLoaded1: false, backgroundImageLoaded2: false });
}

checkLoadingState(){

    setTimeout(() => {
        if ( this.state.backgroundImageLoaded1 && this.state.backgroundImageLoaded2 ){
                this.setState({ showDialog: true });
                this.props.showLoader(false);
        }

    }, 50);
}

changeAdminMode(mode){

    if ( mode === 'mobile' ){
        this.setState({ adminMode: mode, width: this.props.height/1.5, height: this.props.height, showData: false });
    }
    if ( mode === 'pc' ){
        this.setState({ adminMode: mode, width: this.props.width, height: this.props.height, showData: false });
    }

    setTimeout(() => { this.setState({ showData: true }) }, 50);

}

notOpen(ref,nr){

    if (this.timerHandle) {
        clearTimeout(this.timerHandle);
        this.timerHandle = 0;
    }
    if ( ref !== undefined ){
        this.refs[ref].shake();
    }
    if ( nr !== undefined ){
        if ( this.props.todayIs > nr ){
            this.setState({ showFalscherTagDialog: true, mouseOverDoor : nr, falscherTagDialogText: appstrings().strings.doorFail5+' '+nr+appstrings().strings.dezember+' '+appstrings().strings.doorFail6 });
        } else {
            this.setState({ showFalscherTagDialog: true, mouseOverDoor : nr, falscherTagDialogText: appstrings().strings.doorFail1+' '+nr+appstrings().strings.dezember+' '+appstrings().strings.doorFail2 });
        }
    }

    this.timerHandle = setTimeout(() => {

                this.setState({ showFalscherTagDialog: false, mouseOverDoor : 0 });
                this.timerHandle = 0;
    }, 1500);

}


animateStart(ref){

    if ( this.state.showCloseDialogBtn ){

        this.refs[ref].shake();


    } else {

         Animated.sequence([
              Animated.timing(this.animatedRotateY, {
                toValue: 1,
                duration: 500,
                easing: Easing.linear,
              }),
              Animated.timing(this.animatedTranslateX, {
                toValue: 1,
                duration: 500,
                easing: Easing.linear,
              }),
         ]).start();

         this.setState({ isOpen: true });

setTimeout(() => {

         Animated.sequence([
              Animated.timing(this.animatedRotateY, {
                toValue: 0,
                duration: 500,
                easing: Easing.linear,
              }),
              Animated.timing(this.animatedTranslateX, {
                toValue: 0,
                duration: 500,
                easing: Easing.linear,
              }),
         ]).start();

              this.setState({ isOpen: false });


}, 1500);

setTimeout(() => {

         Animated.parallel([
              Animated.timing(this.gewinnX, {
                toValue: 1,
                duration: 1000,
                easing: Easing.linear,
              }),
              Animated.timing(this.gewinnY, {
                toValue: 1,
                duration: 1000,
                easing: Easing.linear,
              }),
              Animated.timing(this.gewinnZindex, {
                toValue: 1,
                duration: 100,
                easing: Easing.linear,
              }),
              Animated.timing(this.gewinnWidth, {
                toValue: 1,
                duration: 1000,
                easing: Easing.linear,
              }),
              Animated.timing(this.gewinnHeight, {
                toValue: 1,
                duration: 1000,
                easing: Easing.linear,
              }),
              Animated.timing(this.gewinnShadow, {
                toValue: 1,
                duration: 500,
                easing: Easing.linear,
              }),
              Animated.timing(this.gewinnMargin, {
                toValue: 1,
                duration: 500,
                easing: Easing.linear,
              }),
         ]).start();

setTimeout(() => {
this.refs.gewinnViewGift.zoomOut(125);
setTimeout(() => { this.setState({ showGift: false, showGewinn: true }) }, 125);
}, 750);

setTimeout(() => { this.setState({ showCloseDialogBtn: true }) }, 1500);
setTimeout(() => { this.setState({ showWeiterDialogBtn: true }) }, 2000);
setTimeout(() => { this.props.gewinnPerEmailSenden() }, 2500);

}, 500);

}

}

closeDialog(){

    this.setState({ showCloseDialogBtn: false, showWeiterDialogBtn: false, showWeiterDialogBtn2: false, showSozialMediaBtns: false, showGewinn: false, showGift: true });

    this.gewinnX.setValue(0);
    this.gewinnY.setValue(0);
    this.gewinnZindex.setValue(0);
    this.gewinnWidth.setValue(0);
    this.gewinnHeight.setValue(0);
    this.gewinnShadow.setValue(0);
    this.gewinnMargin.setValue(0);

    this.setState({
    gewinnGutscheincodeTitel: appstrings().strings.gutscheincode,
    gewinnText: appstrings().strings.glueckwunsch+appstrings().strings.gewinnText1+this.state.tagesGewinnText+appstrings().strings.gewinnText2,
    });

}

changeGewinnText(instanz){


    if ( instanz === 0 ){

        this.setState({ showWeiterDialogBtn: false, showSozialMediaBtns: false, showGewinn: false });

        setTimeout(() => {

        this.setState({ showWeiterDialogBtn2: true });

        }, 250);
    }

    if ( instanz === 1 ){

        this.setState({ showWeiterDialogBtn2: false });

        setTimeout(() => {

        this.setState({ showSozialMediaBtns: true });

        }, 250);
    }

    if ( instanz === -1 ){

        this.setState({ showWeiterDialogBtn2: false, showGewinn: true, showGift: false });

        setTimeout(() => {

        this.setState({ showWeiterDialogBtn: true });

        }, 250);
    }

}

openFacebook(){

            if ( this.props.deviceArt === 'ios' ){
                Linking.openURL('fb://profile/193079267403934').catch(() => {
                      window.open(urls.facebook, "_blank");
                });
            }

            if ( this.props.deviceArt === 'android' ){
                Linking.openURL('fb://page/193079267403934').catch(() => {
                      window.open(urls.facebook, "_blank");
                });
            }

            if ( this.props.deviceArt === 'pc' ){
                window.open(urls.facebook, "_blank");
            }
            this.sendDataToGoogle('User','Facebook geöffnet');
}


openInstagram(){

            if ( this.props.deviceArt === 'pc' ){
                    window.open(urls.instagram, "_blank");
            } else {
                Linking.openURL('instagram://user?username=urlaubsgruss').catch(() => {
                    window.open(urls.instagram, "_blank");
                });
            }
            this.sendDataToGoogle('User','Instagram geöffnet');
}

openTwitter(){

            if ( this.props.deviceArt === 'pc' ){
                    window.open(urls.twitter, "_blank");
            } else {
                Linking.openURL(urls.twitter).catch(() => {
                    window.open(urls.twitter, "_blank");
                });
            }
            this.sendDataToGoogle('User','Twitter geöffnet');
}



deleteBox(index){

    let data = this.state.data;

    data.splice(index, 1);

    this.setState({ data: data });
}

sizeWidthBigger(index){

    let data = this.state.data;
//alert(data[index].width)
    data[index].width=data[index].width+1;

    this.setState({ data: data });
}

sizeHeightBigger(index){

    let data = this.state.data;
//alert(data[index].width)
    data[index].height=data[index].height+1;

    this.setState({ data: data });
}
sizeWidthSmaler(index){

    let data = this.state.data;
//alert(data[index].width)
    data[index].width=data[index].width-1;

    this.setState({ data: data });
}

sizeHeightSmaler(index){

    let data = this.state.data;
//alert(data[index].width)
    data[index].height=data[index].height-1;

    this.setState({ data: data });
}

sizeLeftBigger(index){

    let data = this.state.data;
//alert(data[index].width)
    data[index].left=data[index].left+1;

    this.setState({ data: data });
}

sizeTopBigger(index){

    let data = this.state.data;
//alert(data[index].width)
    data[index].top=data[index].top+1;

    this.setState({ data: data });
}
sizeLeftSmaler(index){

    let data = this.state.data;
//alert(data[index].width)
    data[index].left=data[index].left-1;

    this.setState({ data: data });
}

sizeTopSmaler(index){

    let data = this.state.data;
//alert(data[index].width)
    data[index].top=data[index].top-1;

    this.setState({ data: data });
}

getInProzentFromHeight(itemheight){

    let height = this.state.height;
    return itemheight*100/height;
}

getInProzentFromWidth(itemwidth){
    let width = this.state.width;
    return itemwidth*100/width;
}

getWidthFromProzent(itemwidthinprozent){

    return itemwidthinprozent*this.state.width/100;
}

getHeightFromProzent(itemheightinprozent){

    return itemheightinprozent*this.state.height/100;
}

addNewBox(){

    let data = this.state.data;
    //let newBox = { 'nummer': parseInt(this.state.adminActiveNr), 'top': parseInt(JSON.stringify(this.state.pan.y)), 'left': parseInt(JSON.stringify(this.state.pan.x)), 'height': this.state.adminActiveHeight, 'width': this.state.adminActiveWidth };
    let newBox = { 'nummer': parseInt(this.state.adminActiveNr), 'top': this.getInProzentFromHeight(parseInt(JSON.stringify(this.state.pan.y))), 'left': this.getInProzentFromWidth(parseInt(JSON.stringify(this.state.pan.x))), 'height': this.getInProzentFromHeight(this.state.adminActiveHeight), 'width': this.getInProzentFromWidth(this.state.adminActiveWidth) };

    //alert(JSON.stringify(newBox));
    data.push(newBox);
    this.setState({ data: data, adminActiveNr: parseInt(this.state.adminActiveNr)+1 });
    //setTimeout(() => { this.setState({ showDoors: true }); }, 250);
    //alert(JSON.stringify(data));
}

getScreenSize(){
    let w = Dimensions.get('window').width;
    let h = Dimensions.get('window').height;
    let isTablet = true;
    if ( h > w ){
        isTablet = false
                if ( w > window.screen.width ){
                    w = window.screen.width;
                    h = window.screen.height-150;
                }
    }

    return { width: w, height: h, isTablet:isTablet };
}

  render() {


        var admindata = [];

                    this.state.data.sort((a, b) => a.nummer - b.nummer).forEach(function (item,index) {

        admindata.push(
                <Text>{JSON.stringify(item)+','}</Text>
                );
        });

        var mDoors = [];

                    this.state.data.forEach(function (item,index) {

if ( item.nummer === this.props.todayIs ){
                        mDoors.push(

                            <Animatable.View ref={'Door'+item.nummer} key={'Door'+item.nummer} style={{   }}
                                onMouseEnter={()=>{ this.setState({ mouseOverDoor : item.nummer }) }}
                                onMouseLeave={()=>{ if ( this.getScreenSize().isTablet === true ) { this.setState({ mouseOverDoor : 0 });}  }}

                                >



            <Animated.View style={{ overflow:'hidden', borderStyle: 'dashed', borderColor:doorBorderColor, borderWidth:doorBorderWidth, width: this.getWidthFromProzent(item.width), height: this.getHeightFromProzent(item.height), top:this.getHeightFromProzent(item.top), left: this.getWidthFromProzent(item.left)-(this.getWidthFromProzent(item.width)/2), position:'absolute',
            transform: [{ rotateY: this.animatedRotateY.interpolate({  inputRange: [0, 1],  outputRange: ['0deg', '90deg']}) },{perspective: 300},{ translateX: this.animatedTranslateX.interpolate({  inputRange: [0, 1],  outputRange: [(this.getWidthFromProzent(item.width)/2), (this.getWidthFromProzent(item.width)/2)] }) },{ translateY: 0 }],
            shadowColor: this.props.shadowColorDoor, shadowOffset: { width: 0, height: 0 }, shadowRadius: 5, shadowOpacity: this.state.mouseOverDoor===item.nummer?0.5:0.2 }}
            onLayout={(event) => {
                                              this.setState({         gewinnViewTop: event.nativeEvent.layout.y,
                                                                      gewinnViewLeft: event.nativeEvent.layout.x,
                                                                      gewinnViewWidth: event.nativeEvent.layout.width,
                                                                      gewinnViewHeight: event.nativeEvent.layout.height })
                                            }}>

                  <Image style={{ top:-this.getHeightFromProzent(item.top)-doorBorderWidth, left:-this.getWidthFromProzent(item.left)-doorBorderWidth, width: this.state.width, height:this.state.height }}
                    resizeMode="cover" source={require('./images/Adventskalenderbild.jpg')} onLoad={()=>{ this.setState({ backgroundImageLoaded1: true }); this.checkLoadingState(); }}/>

                  <TouchableOpacity style={{ position:'absolute', top:0, left:0, width: this.getWidthFromProzent(item.width), height: this.getHeightFromProzent(item.height),
                   justifyContent:'center', alignItems:'center', }} onPress={() => {this.animateStart('Door'+item.nummer); }}>

                <Text style={{ fontSize: this.state.mouseOverDoor===item.nummer?this.props.doorNrSize+10:this.props.doorNrSize, fontWeight:'bold', color:doorNumberColor,
                 textShadowColor: this.props.shadowColorDoorNr, textShadowOffset: { width: 2, height: 2 }, textShadowRadius: 5, }}>{item.nummer}</Text>

                  </TouchableOpacity>
                                    { this.state.isAdminMode ?
                                            <TouchableOpacity
                                                  onPress={()=>{ this.deleteBox(index) }}
                                                  style ={{ position:'absolute', width:20, height:20, top:0, right: 0, borderRadius:10, backgroundColor:MainColor.green, alignItems:'center', justifyContent:'center'  }}>
                                                  <Icon size={15} name='close' type='material-community' color={'#ffffff'}/>
                                            </TouchableOpacity>:null
                                    }
            </Animated.View>

                            </Animatable.View>
                        );
} else {

        mDoors.push(

        <Animatable.View ref={'Door'+item.nummer} key={'Door'+item.nummer} style={{ borderStyle: 'dashed', borderColor:doorBorderColor, borderWidth:doorBorderWidth, width: this.getWidthFromProzent(item.width), height: this.getHeightFromProzent(item.height), top:this.getHeightFromProzent(item.top), left: this.getWidthFromProzent(item.left),
                        position:'absolute', shadowColor: this.props.shadowColorDoor, shadowOffset: { width: 0, height: 0 }, shadowRadius: 5, shadowOpacity: this.state.mouseOverDoor===item.nummer?0.5:0.2 }}
                        onMouseEnter={()=>{ this.setState({ mouseOverDoor : item.nummer }) }}
                        onMouseLeave={()=>{ if ( this.getScreenSize().isTablet === true ) { this.setState({ mouseOverDoor : 0 });}  }}
                        >

               <TouchableOpacity style={{ width:'100%', height:'100%', justifyContent:'center', alignItems:'center' }}

                onPress={() => {this.notOpen('Door'+item.nummer, item.nummer) }}>

               <Text style={{ position:'absolute', fontSize: this.state.mouseOverDoor===item.nummer?this.props.doorNrSize+10:this.props.doorNrSize, fontWeight:'bold', color:doorNumberColor,
                textShadowColor: this.props.shadowColorDoorNr, textShadowOffset: { width: 2, height: 2 }, textShadowRadius: 5,  }}>{item.nummer}</Text>


               </TouchableOpacity>

{ this.state.isAdminMode ?
                          <TouchableOpacity
                                onPress={()=>{ this.deleteBox(index) }}
                                style ={{ position:'absolute', width:20, height:20, top:-10, right: -10, borderRadius:10, backgroundColor:MainColor.signal, alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={15} name='close' type='material-community' color={'#ffffff'}/>
                          </TouchableOpacity>:null
}
{ this.state.isAdminMode ?
                          <View style={{ position:'absolute', bottom:0, left: 0, flexDirection:'row' }}>
                          <TouchableOpacity
                                onPress={()=>{ this.sizeWidthBigger(index) }}
                                style ={{ width:20, height:20, borderRadius:10, backgroundColor:MainColor.primary, alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={15} name='arrow-right' type='material-community' color={MainColor.gelb}/>
                          </TouchableOpacity>
                          <TouchableOpacity
                                onPress={()=>{ this.sizeWidthSmaler(index) }}
                                style ={{ width:20, height:20, borderRadius:10, backgroundColor:MainColor.primary, alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={15} name='arrow-left' type='material-community' color={MainColor.gelb}/>
                          </TouchableOpacity>
                          <TouchableOpacity
                                onPress={()=>{ this.sizeHeightBigger(index) }}
                                style ={{ width:20, height:20, borderRadius:10, backgroundColor:MainColor.gelb, alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={15} name='arrow-down' type='material-community' color={MainColor.primary}/>
                          </TouchableOpacity>
                          <TouchableOpacity
                                onPress={()=>{ this.sizeHeightSmaler(index) }}
                                style ={{ width:20, height:20, borderRadius:10, backgroundColor:MainColor.gelb, alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={15} name='arrow-up' type='material-community' color={MainColor.primary}/>
                          </TouchableOpacity>
                          </View>:null
}
{ this.state.isAdminMode ?
                          <View style={{ position:'absolute', top:0, left: 0, flexDirection:'row' }}>
                          <TouchableOpacity
                                onPress={()=>{ this.sizeLeftBigger(index) }}
                                style ={{ width:20, height:20, borderRadius:10, backgroundColor:MainColor.primary, alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={15} name='arrow-right' type='material-community' color={MainColor.gelb}/>
                          </TouchableOpacity>
                          <TouchableOpacity
                                onPress={()=>{ this.sizeLeftSmaler(index) }}
                                style ={{ width:20, height:20, borderRadius:10, backgroundColor:MainColor.primary, alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={15} name='arrow-left' type='material-community' color={MainColor.gelb}/>
                          </TouchableOpacity>
                          <TouchableOpacity
                                onPress={()=>{ this.sizeTopBigger(index) }}
                                style ={{ width:20, height:20, borderRadius:10, backgroundColor:MainColor.gelb, alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={15} name='arrow-down' type='material-community' color={MainColor.primary}/>
                          </TouchableOpacity>

                          <TouchableOpacity
                                onPress={()=>{ this.sizeTopSmaler(index) }}
                                style ={{ width:20, height:20, borderRadius:10, backgroundColor:MainColor.gelb, alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={15} name='arrow-up' type='material-community' color={MainColor.primary}/>
                          </TouchableOpacity>
                          </View>:null
}
        </Animatable.View>

                );
}
                    }.bind(this));


    const panStyle = {
      transform: this.state.pan.getTranslateTransform()
    }


    return (

    <>
      <style type="text/css">{`
        @font-face {
          font-family: 'FontAwesome';
          src: url(${require('react-native-vector-icons/Fonts/FontAwesome.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'MaterialCommunityIcons';
          src: url(${require('react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'CaveatBrush-Regular';
          src: url(${require('./fonts/CaveatBrush.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'Montserrat-Regular';
          src: url(${require('./fonts/Montserrat-Regular.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'Montserrat-Medium';
          src: url(${require('./fonts/Montserrat-Medium.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'Montserrat-Bold';
          src: url(${require('./fonts/Montserrat-Bold.ttf')}) format('truetype');
        }
      `}</style>

{ this.state.showData ?
<View style={{ width:'100%', height:'100%' }}>

<SnowStorm excludeMobile={false} />



<Image style={{ position:'absolute', top:0, left:0, width: this.state.width, height:this.state.height, opacity:1 }}
        resizeMode="cover" source={require('./images/Adventskalenderbild.jpg')} onLoad={()=>{ this.setState({ backgroundImageLoaded2: true }); this.checkLoadingState(); }}/>

{ this.state.showDoors ?
<View style={{ zIndex: 2, position:'absolute', top:0, left:0, width: this.state.width, height:this.state.height, opacity:1 }}>
{mDoors}
</View>:null
}

{
this.state.showDialog ?
      <Animated.View style={{ width: this.gewinnWidth.interpolate({  inputRange: [0, 1],  outputRange: [this.state.gewinnViewWidth-(doorBorderWidth*2), this.getScreenSize().isTablet?this.state.width/3:this.state.width/5*4] }),
                            height: this.gewinnHeight.interpolate({  inputRange: [0, 1],  outputRange: [this.state.gewinnViewHeight-(doorBorderWidth*2), this.state.height/2] }),
                            zIndex: this.gewinnZindex.interpolate({  inputRange: [0, 1],  outputRange: [1, 9] }),
                            top: this.gewinnX.interpolate({  inputRange: [0, 1],  outputRange: [this.state.gewinnViewTop+doorBorderWidth,(this.state.height/2)-(this.state.height/2/2)] }),
                            left: this.gewinnY.interpolate({  inputRange: [0, 1],  outputRange: [this.state.gewinnViewLeft+doorBorderWidth,(this.state.width/2)-(this.getScreenSize().isTablet?this.state.width/3/2:this.state.width/5*4/2)] }),
                            backgroundColor:'#ffffff', borderRadius: 15, justifyContent:'center', borderWidth:4, borderColor:'#ffffff',
                            position:'absolute', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity: this.gewinnShadow.interpolate({  inputRange: [0, 1],  outputRange: [0, 0.5] }) }}>



<View style={{ width:'100%', height:'100%', backgroundColor:'#ffffff', padding:5, borderRadius:15, borderWidth:3, borderColor:MainColor.primary, alignItems:'center', justifyContent:'center' }}>


{
this.state.showGift ?
<Animatable.Image ref={'gewinnViewGift'} style={{ width:'50%', height:'50%', opacity:1 }}
                resizeMode="contain" source={require("./images/gift.jpg")} />:null
}

{
this.state.showGewinn ?
<Animatable.View ref={'gewinnViewText1'} animation="bounceIn" style={{ width:'100%', height:'100%', alignItems:'center', justifyContent:'center' }}>

           <Text style={{ fontFamily:'Montserrat-Medium', marginTop: -25, fontSize: this.getScreenSize().isTablet?this.getScreenSize().width/60:this.getScreenSize().width/40*1.5, width:'90%', textAlign:'center', color:MainColor.text }}>{this.state.gewinnText}</Text>
           <Text style={{ fontFamily:'Montserrat-Medium', marginTop: this.getScreenSize().isTablet?this.getScreenSize().width/60:this.getScreenSize().width/25, fontSize: this.getScreenSize().isTablet?this.getScreenSize().width/75:this.getScreenSize().width/75*2, width:'80%', textAlign:'center', color:MainColor.graydark }}>{this.state.gewinnGutscheincodeTitel}</Text>
           <Text style={{ fontFamily:'Montserrat-Bold', marginTop: 10, fontSize: this.getScreenSize().isTablet?this.getScreenSize().width/50:this.getScreenSize().width/50*2, width:'80%', textAlign:'center', color:MainColor.text }}>{this.state.gewinnGutscheincode}</Text>
           <Text style={{ fontFamily:'Montserrat-Medium', marginTop: 15, fontSize: this.getScreenSize().isTablet?this.getScreenSize().width/125:this.getScreenSize().width/90*2, width:'60%', textAlign:'center', color:MainColor.graydark }}>{this.state.gewinnGutscheincodeHaltbarkeit}</Text>

{
this.state.showWeiterDialogBtn ?

           <Animatable.View animation="bounceIn" style={{ position:'absolute', bottom:-37.5, backgroundColor:MainColor.green, borderRadius:25, width:'40%', alignSelf:'center', height: 50, borderWidth:2, borderColor:'#ffffff', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity: 0.5 }}>
           <TouchableOpacity style={{ height: '100%', width:'100%', alignItems:'center', justifyContent:'center'}}
               onPress={() => { this.changeGewinnText(0); }}>
               <Text style={{ fontFamily:'Montserrat-Bold', fontSize:this.getScreenSize().isTablet?28:20, textAlign:'center', color:'#ffffff' }}>{appstrings().strings.weiter}</Text>
           </TouchableOpacity>
           </Animatable.View>:null
}

</Animatable.View>:null
}

{
this.state.showWeiterDialogBtn2 ?

<Animatable.View ref={'gewinnViewText2'} animation="bounceIn" style={{ width:'100%', height:'100%', alignItems:'center', justifyContent:'center' }}>

           <Text style={{ fontFamily:'Montserrat-Medium', lineHeight:this.getScreenSize().isTablet?(this.getScreenSize().width/50)*2:(this.getScreenSize().width/40*2)*2, marginTop: -25, fontSize: this.getScreenSize().isTablet?this.getScreenSize().width/60:this.getScreenSize().width/40*2, width:'90%', textAlign:'center', color:MainColor.text }}>{appstrings().strings.gewinnperemail}</Text>


           <View style={{ position:'absolute', bottom:-37.5, width:'80%', alignSelf:'center', height: 50, flexDirection:'row' }}>
           <TouchableOpacity style={{ height: '100%', width:'47.5%', marginRight:'2.5%', backgroundColor:MainColor.text, borderRadius:25, alignItems:'center', justifyContent:'center', borderWidth:2, borderColor:'#ffffff', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity: 0.5, }}
               onPress={() => { this.changeGewinnText(-1); }}>
               <Text style={{ fontFamily:'Montserrat-Bold', fontSize:this.getScreenSize().isTablet?28:20, textAlign:'center', color:'#ffffff' }}>{appstrings().strings.back}</Text>
           </TouchableOpacity>
           <TouchableOpacity style={{ height: '100%', width:'47.5%', marginLeft:'2.5%', backgroundColor:MainColor.green, borderRadius:25, alignItems:'center', justifyContent:'center', borderWidth:2, borderColor:'#ffffff', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity: 0.5, }}
               onPress={() => { this.changeGewinnText(1); }}>
               <Text style={{ fontFamily:'Montserrat-Bold', fontSize:this.getScreenSize().isTablet?28:20, textAlign:'center', color:'#ffffff' }}>{appstrings().strings.weiter}</Text>
           </TouchableOpacity>
           </View></Animatable.View>:null
}
{
this.state.showSozialMediaBtns ?
<Animatable.View ref={'gewinnViewText3'} animation="bounceIn" style={{ width:'100%', height:'100%', alignItems:'center', justifyContent:'center' }}>

           <Text style={{ fontFamily:'Montserrat-Medium', marginTop: -25, fontSize: this.getScreenSize().isTablet?this.getScreenSize().width/60:this.getScreenSize().width/40*1.5, width:'90%', textAlign:'center', color:MainColor.text }}>{appstrings().strings.danke}</Text>
           <Text style={{ fontFamily:'CaveatBrush-Regular', marginTop: 20, fontSize: this.getScreenSize().isTablet?this.getScreenSize().width/50:this.getScreenSize().width/40*2.5, width:'90%', textAlign:'center', color:MainColor.primary }}>{appstrings().strings.danke2}</Text>
           <Text style={{ fontFamily:'Montserrat-Medium', marginTop: this.getScreenSize().isTablet?this.getScreenSize().width/60:this.getScreenSize().width/25, fontSize: this.getScreenSize().isTablet?this.getScreenSize().width/80:this.getScreenSize().width/65*1.75, width:'80%', textAlign:'center', color:MainColor.graydark }}>{appstrings().strings.folgen}</Text>


           <View animation="bounceIn" style={{ position:'absolute', width:'100%', bottom:-37.5, flexDirection:'row', alignItems:'center', justifyContent:'center' }}>

           <TouchableOpacity style={{ height: 45, width:'40%', marginRight:this.getScreenSize().isTablet?'10%':'2.5%', backgroundColor:MainColor.text, borderRadius:25, alignItems:'center', justifyContent:'center', borderWidth:2, borderColor:'#ffffff', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity: 0.5, }}
               onPress={() => { this.changeGewinnText(0); }}>
               <Text style={{ fontFamily:'Montserrat-Bold', fontSize:this.getScreenSize().isTablet?28:20, textAlign:'center', color:'#ffffff' }}>{appstrings().strings.back}</Text>
           </TouchableOpacity>

                                                           <SocialIcon
                                                             style={{ borderWidth:2, borderColor:'#ffffff', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity: 0.5}}
                                                             onPress={()=> { this.openFacebook() }}
                                                             type='facebook'
                                                           />

                                                           <SocialIcon
                                                             style={{borderWidth:2, borderColor:'#ffffff', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity: 0.5}}
                                                             onPress={()=> { this.openInstagram() }}
                                                             type='instagram'
                                                           />

                                                           <SocialIcon
                                                             style={{borderWidth:2, borderColor:'#ffffff', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity: 0.5}}
                                                             onPress={()=> { this.openTwitter() }}
                                                             type='twitter'
                                                           />

           </View></Animatable.View>:null
}
</View>
{
this.state.showCloseDialogBtn ?

           <Animatable.View animation="bounceIn" style={{ position:'absolute', top:-25, right:-25, }}>
           <TouchableOpacity style={{ backgroundColor:MainColor.signal, width: 50, height:50, borderRadius:25, borderWidth:2, borderColor:'#ffffff', alignItems:'center', justifyContent:'center', shadowColor: '#000000', shadowOffset: { width: 5, height: 5 }, shadowRadius: 10, shadowOpacity: 0.5 }}
               onPress={() => { this.closeDialog() }}>
               <Icon size={36} name='close' type='material-community' color={'#ffffff'}/>
           </TouchableOpacity>
           </Animatable.View>:null
}


      </Animated.View>:null
}

        <View style={{ zIndex: 0, overflow:'hidden', width: this.state.gewinnViewWidth-(doorBorderWidth*2)-1, height: this.state.gewinnViewHeight-(doorBorderWidth*2)-1, top:this.state.gewinnViewTop+doorBorderWidth+1, left: this.state.gewinnViewLeft+doorBorderWidth+1,
                        backgroundColor:'#ffffff', position:'absolute', }}>

                    <Svg style={{ marginLeft:-(this.state.gewinnViewWidth/2) }} height={this.state.gewinnViewHeight*2} width={this.state.gewinnViewWidth*2}>

                                        <RadialGradient
                                          id="gradient8"
                                          cx={'50%'}
                                          cy={'50%'}
                                          rx={'50%'}
                                          ry={'50%'}
                                          fx={'50%'}
                                          fy={'50%'}
                                          gradientUnits="userSpaceOnUse"
                                        >
                                  <Stop offset="0" stopColor={'#ffffff'} stopOpacity="0.95" />
                                  <Stop offset="1" stopColor={'#aeaeae'} stopOpacity="0.95" />
                               </RadialGradient>


                                <Rect x={0} y={0} width={'100%'}
                                height={'100%'}
                                fill="url(#gradient8)" />
                    </Svg>


        </View>

{
this.state.showFalscherTagDialog ?


       <Animatable.View ref={'gewinnView'} animation="bounceInDown" style={{ position:'absolute', bottom:100, alignSelf:'center', zIndex:99, width:this.getScreenSize().isTablet?'40%':'90%', backgroundColor:MainColor.signal, borderRadius:15, alignItems:'center', justifyContent:'center',
                                            borderWidth:2, borderColor:'#ffffff', shadowColor: '#ffffff', shadowOffset: { width: -2, height: -2 }, shadowRadius: 10, shadowOpacity: 0.5}}>

           <Text style={{ fontFamily:'Montserrat-Bold', fontSize:this.getScreenSize().isTablet?22:18, width:'100%', padding:15, textAlign:'center', color:'#ffffff' }}>{this.state.falscherTagDialogText}</Text>






        </Animatable.View>:null
}


{ this.state.isAdminMode ?
<Animated.View {...this.panResponder.panHandlers} style={[panStyle,{ zIndex:99999, width:this.state.adminActiveWidth, height:this.state.adminActiveHeight, position:'absolute', top:0, left:0, backgroundColor:MainColor.signal, alignItems:'center', justifyContent:'center'}]}>


                          <TouchableOpacity
                                onPress={()=>{ this.addNewBox() }}
                                style ={{ width:30, height:30, position:'absolute', top:10, left: 10, borderRadius:15, backgroundColor:'#ffffff', alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={20} name='check' type='material-community' color={MainColor.signal}/>

                          </TouchableOpacity>


                <TextInput style={{ outlineWidth: 0, width: 50, fontSize:30, textAlignVertical: 'top',
                                                 color:'#ffffff', textAlign:'center', padding:0}}
                                     value={this.state.adminActiveNr}
                                     placeholder={'Nr.'}
                                     placeholderTextColor={MainColor.plholder}
                                     selectionColor={MainColor.primary}
                                     onChangeText={(text) => this.setState({ adminActiveNr: text })}
                                     blurOnSubmit={false}
                               />
                    <View style={{ flexDirection:'row'}}>
                          <TouchableOpacity
                                onPress={()=>{ this.setState({ adminActiveNr: parseInt(this.state.adminActiveNr)-1}) }}
                                style ={{ width:20, height:20, borderRadius:15, backgroundColor:'#ffffff', alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={20} name='minus' type='material-community' color={MainColor.signal}/>
                          </TouchableOpacity>
                          <TouchableOpacity
                                onPress={()=>{ this.setState({ adminActiveNr: parseInt(this.state.adminActiveNr)+1}) }}
                                style ={{ width:20, height:20, borderRadius:15, backgroundColor:'#ffffff', alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={20} name='plus' type='material-community' color={MainColor.signal}/>
                          </TouchableOpacity>
                    </View>

<View style={{ width: 70, height: 20, flexDirection:'row', position:'absolute', bottom:5, left: 5, justifyContent:'space-around'}}>
                          <TouchableOpacity
                                onPress={()=>{ this.setState({ adminActiveWidth: this.state.adminActiveWidth-10 }) }}
                                style ={{ width:20, height:20, borderRadius:10, backgroundColor:'#ffffff', alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={20} name='minus' type='material-community' color={MainColor.signal}/>

                          </TouchableOpacity>

                          <TouchableOpacity
                                onPress={()=>{ this.setState({ adminActiveWidth: this.state.adminActiveWidth-10 }) }}
                                style ={{ width:20, height:20, borderRadius:10, backgroundColor:'#ffffff', alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={15} name='arrow-expand-horizontal' type='material-community' color={MainColor.signal}/>

                          </TouchableOpacity>

                          <TouchableOpacity
                                onPress={()=>{ this.setState({ adminActiveWidth: this.state.adminActiveWidth+10 }) }}
                                style ={{ width:20, height:20, borderRadius:10, backgroundColor:'#ffffff', alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={20} name='plus' type='material-community' color={MainColor.signal}/>

                          </TouchableOpacity>
</View>

<View style={{ width: 20, height: 70, flexDirection:'column', position:'absolute', top:5, right: 5, justifyContent:'space-around'}}>
                          <TouchableOpacity
                                onPress={()=>{ this.setState({ adminActiveHeight: this.state.adminActiveHeight-10 }) }}
                                style ={{ width:20, height:20, borderRadius:10, backgroundColor:'#ffffff', alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={20} name='minus' type='material-community' color={MainColor.signal}/>

                          </TouchableOpacity>

                          <TouchableOpacity
                                style ={{ width:20, height:20, borderRadius:10, backgroundColor:'#ffffff', alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={15} name='arrow-expand-vertical' type='material-community' color={MainColor.signal}/>

                          </TouchableOpacity>

                          <TouchableOpacity
                                onPress={()=>{ this.setState({ adminActiveHeight: this.state.adminActiveHeight+10 }) }}
                                style ={{ width:20, height:20, borderRadius:10, backgroundColor:'#ffffff', alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={20} name='plus' type='material-community' color={MainColor.signal}/>

                          </TouchableOpacity>
</View>


</Animated.View>:null
}

{ this.state.isAdminMode ?
<View style={{ zIndex:99999, position:'absolute', right:0, flexDirection:'row'}}>
                          <TouchableOpacity
                                onPress={()=>{ this.setState({ showAdminData: !this.state.showAdminData }) }}
                                style ={{ width:30, height:30, borderRadius:15, backgroundColor:'#ffffff', alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={18} name='guy-fawkes-mask' type='material-community' color={this.state.showAdminData?MainColor.green:MainColor.signal}/>

                          </TouchableOpacity>

                          <TouchableOpacity
                                onPress={()=>{ this.setState({ data: [] }) }}
                                style ={{ width:30, height:30, borderRadius:15, backgroundColor:'#ffffff', alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={24} name='delete-forever' type='material-community' color={this.state.data.length===0?MainColor.green:MainColor.signal}/>

                          </TouchableOpacity>

                          <TouchableOpacity
                                onPress={()=>{ this.changeAdminMode('mobile') }}
                                style ={{ width:30, height:30, borderRadius:15, backgroundColor:'#ffffff', alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={20} name='cellphone' type='material-community' color={this.state.adminMode==='mobile'?MainColor.green:MainColor.signal}/>

                          </TouchableOpacity>

                          <TouchableOpacity
                                onPress={()=>{ this.changeAdminMode('pc') }}
                                style ={{ width:30, height:30, borderRadius:15, backgroundColor:'#ffffff', alignItems:'center', justifyContent:'center'  }}>
                                <Icon size={20} name='monitor' type='material-community' color={this.state.adminMode==='pc'?MainColor.green:MainColor.signal}/>

                          </TouchableOpacity>


</View>:null
}

{ this.state.isAdminMode && this.state.showAdminData ?
<View style={{ zIndex:99999, position:'absolute', width:this.state.width-100, height: this.state.height-100, margin:50, backgroundColor:'#ffffff'}}>
<ScrollView style={{ height: this.state.height-100, width:this.state.width-100, }} contentContainerStyle={{  }}>

                {admindata}

</ScrollView>
</View>:null
}






</View>:null
}

</>
    );
  }
}


/*

<Text style={{ marginTop: this.getScreenSize().isTablet?this.getScreenSize().width/50:this.getScreenSize().width/25, fontSize: this.getScreenSize().isTablet?this.getScreenSize().width/75:this.getScreenSize().width/75*2, width:'80%', textAlign:'center', fontWeight:'bold', color:MainColor.graydark }}>{appstrings().strings.gutscheincodekundenkonto}</Text>



alter hintergrund von türchen heute mit svg verlauf
                <View style={{ backgroundColor:doorBorderColor, padding:doorBorderWidth, width: this.getWidthFromProzent(item.width)-(doorBorderWidth*2), height: this.getHeightFromProzent(item.height)-(doorBorderWidth*2) }}>

                    <Svg style={{ }} height={this.getHeightFromProzent(item.height)+50} width={this.getWidthFromProzent(item.width)+50}>

                                        <RadialGradient
                                          id="gradient8"
                                          cx={(this.getWidthFromProzent(item.width)-(doorBorderWidth*2))/2}
                                          cy={(this.getHeightFromProzent(item.height)-(doorBorderWidth*2))/2}
                                          rx={(this.getWidthFromProzent(item.width)-(doorBorderWidth*2))/2}
                                          ry={(this.getHeightFromProzent(item.height)-(doorBorderWidth*2))/2}
                                          fx={(this.getWidthFromProzent(item.width)-(doorBorderWidth*2))/2}
                                          fy={(this.getHeightFromProzent(item.height)-(doorBorderWidth*2))/2}
                                          gradientUnits="userSpaceOnUse"
                                        >
                                  <Stop offset="0" stopColor={'#ffffff'} stopOpacity="0.75" />
                                  <Stop offset="1" stopColor={'#123456'} stopOpacity="1" />
                               </RadialGradient>

                                <Rect x="0" y="0" height={this.getHeightFromProzent(item.height)+50} width={this.getWidthFromProzent(item.width)+50}
                                     fill="url(#gradient8)" />

                    </Svg>



                </View>


                //GEWINNVIEW vor Umbau von Animated auf Animatable

                       <Animatable.View ref={'gewinnView'} style={{ width:'100%', height:'100%', backgroundColor:'#ffffff', padding:5, borderRadius:15, borderWidth:2, borderColor:MainColor.text, alignItems:'center', justifyContent:'center' }}>

                           <Animated.Text style={{ marginTop:this.gewinnMargin.interpolate({  inputRange: [0, 1],  outputRange: [0, this.getScreenSize().isTablet?-this.getScreenSize().width/50:-this.getScreenSize().width/25] }), fontSize:this.gewinnFontSize.interpolate({  inputRange: [0, 1, 2],  outputRange: [this.getScreenSize().isTablet?this.getScreenSize().width/50/4:this.getScreenSize().width/50/4, this.getScreenSize().isTablet?this.getScreenSize().width/60:this.getScreenSize().width/55*2, 0] }), width:'90%', textAlign:'center', fontWeight:'bold', color:MainColor.text }}>{this.state.gewinnText}</Animated.Text>

                           <Animated.Text style={{ marginTop: this.gewinnMargin.interpolate({  inputRange: [0, 1],  outputRange: [5, this.getScreenSize().isTablet?this.getScreenSize().width/50:this.getScreenSize().width/25] }), fontSize:this.gewinnFontSize.interpolate({  inputRange: [0, 1, 2],  outputRange: [this.getScreenSize().isTablet?this.getScreenSize().width/100/4:this.getScreenSize().width/75/4, this.getScreenSize().isTablet?this.getScreenSize().width/75:this.getScreenSize().width/75*2, 0] }), width:'80%', textAlign:'center', fontWeight:'bold', color:MainColor.graydark }}>{this.state.gewinnGutscheincodeTitel}</Animated.Text>
                { this.state.showGewinnGutscheincode ?
                           <Animated.Text style={{ marginTop:5, fontSize:this.gewinnFontSize.interpolate({  inputRange: [0, 1, 2],  outputRange: [this.getScreenSize().isTablet?this.getScreenSize().width/50/4:this.getScreenSize().width/50/4, this.getScreenSize().isTablet?this.getScreenSize().width/50:this.getScreenSize().width/50*2, 0] }), width:'90%', textAlign:'center', fontWeight:'bold', color:MainColor.text }}>{this.state.gewinnGutscheincode}</Animated.Text>:null
                }

                { this.state.showGewinnGutscheincode ?
                           <Animated.Text style={{ marginTop:10, fontSize:this.gewinnFontSize.interpolate({  inputRange: [0, 1, 2],  outputRange: [this.getScreenSize().isTablet?this.getScreenSize().width/200/4:this.getScreenSize().width/125/4, this.getScreenSize().isTablet?this.getScreenSize().width/125:this.getScreenSize().width/125*2, 0] }), width:'60%', textAlign:'center', fontWeight:'bold', color:MainColor.graydark }}>{this.state.gewinnGutscheincodeHaltbarkeit}</Animated.Text>:null
                }


                        </Animatable.View>
*/